var React = require('react');

function ShuttleVan (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M160 320a80 80 0 1 0 80 80 80 80 0 0 0-80-80zm320 0a80 80 0 1 0 80 80 80 80 0 0 0-80-80z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M628.88 210.65L494.39 49.27A48 48 0 0 0 457.52 32H32A32 32 0 0 0 0 64v288a32 32 0 0 0 32 32h17.14a112 112 0 0 1 221.72 0h98.28a112 112 0 0 1 221.72 0H608a32 32 0 0 0 32-32V241.38a48.05 48.05 0 0 0-11.12-30.73zM160 192H64V96h96zm160 0h-96V96h96zm64 0V96h66l80 96z","className":"fa-primary","key":2})]);
}

ShuttleVan.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = ShuttleVan;

ShuttleVan.default = ShuttleVan;
